import classnames from 'classnames';
import useWorklogStyles from './useWorklogStyles';

const useDiffHighlight = () => {
  const classes = useWorklogStyles();
  return ({ changed, removed, variant = 'mismatch' } = {}) => {
    const isHistory = variant === 'history';
    return classnames(
      changed ? (isHistory ? classes.showDiff : classes.wlHoursMismatch) : null,
      removed ? (isHistory ? classes.showDiffRemoved : classes.wlHoursMismatchRemoved) : null,
    );
  };
};

export default useDiffHighlight;
